import React from 'react';
import './iconalifmobi.scss';

const IconAlifMobi = () => {
  return (
    <div className="icon-alif-mobi-container">
      <div>
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" rx="24" fill="#37A134" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29 15H19L19 33H29V15ZM19 13C17.8954 13 17 13.8954 17 15V33C17 34.1046 17.8954 35 19 35H29C30.1046 35 31 34.1046 31 33V15C31 13.8954 30.1046 13 29 13H19ZM21 17C21 16.4477 21.4477 16 22 16H26C26.5523 16 27 16.4477 27 17C27 17.5523 26.5523 18 26 18H22C21.4477 18 21 17.5523 21 17ZM23.5 30C22.9477 30 22.5 30.4477 22.5 31C22.5 31.5523 22.9477 32 23.5 32H24.5C25.0523 32 25.5 31.5523 25.5 31C25.5 30.4477 25.0523 30 24.5 30H23.5Z"
            fill="white"
          />
        </svg>
      </div>
      <div>
        <div className="alif-mobi-label">alif mobi</div>
        <div className="alif-mobi-download">cкачайте бесплатно</div>
      </div>
    </div>
  );
};

export default IconAlifMobi;
